import CollectionAPI from 'api/Collection';
import ACTIONS from 'state/constants';
import Log from 'utils/Log';

export const setCustomCollectionData = data => async dispatch => {
  dispatch({ type: ACTIONS.SET_CUSTOM_COLLECTION_DATA, payload: { data } });
};

export const fetchCustomCollection = handle => async dispatch => {
  dispatch({
    type: ACTIONS.FETCH_CUSTOM_COLLECTION_REQUEST,
  });

  try {
    const collection = await CollectionAPI.fetchCollection({ handle });

    dispatch({
      type: ACTIONS.FETCH_CUSTOM_COLLECTION_SUCCESS,
      payload: { collection },
    });
  } catch (error) {
    Log.error(error, `Fetch collection:${handle} failed.`);

    dispatch({ type: ACTIONS.FETCH_CUSTOM_COLLECTION_FAILURE, payload: error.message });
  }
};

export const setMasterProductCardProduct =
  ({ masterHandle, productHandle }) =>
  dispatch => {
    dispatch({
      type: ACTIONS.SET_MASTER_PRODUCT_CARD_PRODUCT,
      payload: { masterHandle, productHandle },
    });
  };

export const setMasterProductCardCarouselIndex =
  ({ masterHandle, carouselIndex }) =>
  dispatch => {
    dispatch({
      type: ACTIONS.SET_MASTER_PRODUCT_CARD_CAROUSEL_INDEX,
      payload: { masterHandle, carouselIndex },
    });
  };

export const setCustomCollectionPageStructuredData =
  ({ faqItems, description, name }) =>
  dispatch => {
    dispatch({
      type: ACTIONS.SET_COLLECTION_STRUCTURED_DATA,
      payload: { faqItems, description, name },
    });
  };

export const trackStoryCardCtaLinkClick =
  ({
    type,
    location,
    name,
    url,
    value,
    copy,
    campaignName,
    experienceName,
    variationName,
    variationId,
  }) =>
  dispatch => {
    dispatch({
      type: ACTIONS.TRACK_EVENT,
      eventCategory: 'Collection',
      eventAction: 'Story Card',
      eventLabel: url,
    });

    dispatch({
      type: ACTIONS.TRACK_CTA_CLICK_EVENT,
      payload: {
        type,
        location,
        name,
        url,
        value,
        copy,
        campaignName,
        experienceName,
        variationName,
        variationId,
      },
    });
  };
